import {
  DestroyRef,
  EnvironmentProviders,
  ErrorHandler,
  inject,
  Injector,
  makeEnvironmentProviders,
  provideBrowserGlobalErrorListeners,
  provideEnvironmentInitializer
} from '@angular/core';
import { config } from 'rxjs';

export function provideApplicationErrorHandling(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideBrowserGlobalErrorListeners(),
    provideEnvironmentInitializer(() => {
      const injector = inject(Injector);
      const previousHandler = config.onUnhandledError;
      const handleError = (error: unknown) => injector.get(ErrorHandler).handleError(error);

      config.onUnhandledError = handleError;
      inject(DestroyRef).onDestroy(() => {
        if (config.onUnhandledError === handleError) {
          config.onUnhandledError = previousHandler;
        }
      });
    })
  ]);
}
